import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpRequest,
  HttpEvent,
  HttpEventType,
} from "@angular/common/http";
import { Events } from "ionic-angular";
import { API } from "@config/Api";
@Injectable()
export class ApiService {
  private __errors_call = {
    "73": false,
    "79": false,
    "83": false,
    "89": false,
    "97": false,
    "53": false,
    "54": false,
    "71": false,
  };
  private __token: string;
  // private __timeloop: Array<any> = [];
  private __is_ready: boolean = false;
  private __REST_WEB_SERVER?: string = `${API.__REST_API_URL}/`;
  private __REST_API_SERVER?: string = `${API.__REST_API_URL}/api/`;
  private __HEADER?: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });

  constructor(private _httpCtrl: HttpClient, private _eventCtrl: Events) {}
  public authenticate(token: string): Promise<null> {
    this.__token = token;
    Object.keys(this.__errors_call).forEach((key) => {
      this.__errors_call[key] = false;
    });
    return new Promise((resolve) => {
      this.__HEADER = this.__HEADER.set("Authorization", `Bearer ${token}`);
      resolve(null);
    });
  }
  public loadBlob(url): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("GET", url, {
            headers: this.__HEADER,
            reportProgress: true,
            responseType: "blob",
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            if (HttpEventType.Response == event.type) {
              resolve(event.body);
            }
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
  public media(path: string, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("POST", `${API.__REST_API_URL}/${path}`, data, {
            headers: this.__HEADER,
            reportProgress: true,
            responseType: "blob",
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            if (HttpEventType.Response == event.type) {
              resolve(event.body);
            }
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public get(
    path: string,
    loader: boolean = true,
    api: boolean = true
  ): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);
    return new Promise((resolve, reject) => {
      const url: string = api
        ? `${this.__REST_API_SERVER}${path}`
        : `${this.__REST_WEB_SERVER}${path}`;
      this._httpCtrl
        .request(
          new HttpRequest("GET", url, {
            responseType: "json",
            headers: this.__HEADER,
            reportProgress: true,
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                break;
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.DownloadProgress:
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (error) => {
            if (error.status) {
              if ((error.status = 0)) {
                this.__nointernet();
              }
            }
            loader
              ? this._eventCtrl.publish("page:loading:status", false)
              : null;
            reject(error);
          }
        );
    });
  }
  public put(path: string, data: any, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);

    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("PUT", this.__REST_API_SERVER + path, data, {
            headers: this.__HEADER,
            reportProgress: true,
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (error) => {
            if (error.status) {
              if ((error.status = 0)) {
                this.__nointernet();
              }
            }
            loader
              ? this._eventCtrl.publish("page:loading:status", false)
              : null;
            reject(error);
          }
        );
    });
  }
  public auth(path: string, data: any, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest(
            "POST",
            this.__REST_WEB_SERVER + "auth/" + path,
            data,
            {
              headers: this.__HEADER,
              reportProgress: true,
            }
          )
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (res) => {
            reject(res);
            if (res.status) {
              if ((res.status = 0)) {
                this.__nointernet();
              }
              if (res.error) {
                this.__switchError(res.error.code);
              }
            }
          }
        );
    });
  }
  public postdownload(path: string, data: any, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);

    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("POST", this.__REST_WEB_SERVER + path, data, {
            headers: this.__HEADER,
            reportProgress: true,
            responseType: "blob",
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (res) => {
            reject(res);
            if (res.status) {
              if ((res.status = 0)) {
                this.__nointernet();
              }
              if (res.error) {
                this.__switchError(res.error.code);
              }
            }
          }
        );
    });
  }

  public call(path: string, data: any = undefined, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);
    return new Promise((resolve, reject) => {
      if( data){

    
      this._httpCtrl
        .request(
          new HttpRequest("POST", this.__REST_WEB_SERVER + path, data, {
            headers: this.__HEADER,
            reportProgress: true,
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (res) => {
            reject(res);
            if (res.status) {
              if ((res.status = 0)) {
                this.__nointernet();
              }
              if (res.error) {
                this.__switchError(res.error.code);
              }
            }
          }
        );
      }else{
      this._httpCtrl
      .request(
        new HttpRequest("GET", this.__REST_WEB_SERVER + path, {
          headers: this.__HEADER,
          reportProgress: true,
        })
      )
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              this._eventCtrl.publish("page:loading:progress", 10);
              break;
            case HttpEventType.ResponseHeader:
              this._eventCtrl.publish("page:loading:progress", 25);
              break;
            case HttpEventType.DownloadProgress:
              this._eventCtrl.publish("page:loading:progress", 50);
              break;
            case HttpEventType.Response:
              this._eventCtrl.publish("page:loading:progress", 100);
              setTimeout(() => {
                loader
                  ? this._eventCtrl.publish("page:loading:status", false)
                  : null;
              }, 500);
              resolve(event.body);
              break;
          }
        },
        (res) => {
          reject(res);
          if (res.status) {
            if ((res.status = 0)) {
              this.__nointernet();
            }
            if (res.error) {
              this.__switchError(res.error.code);
            }
          }
        }
      );
      }
    });
  }
  private performPost(
    path: string,
    data: any,
    loader: boolean = true,
    resolve,
    reject
  ) {
    this._httpCtrl
      .request(
        new HttpRequest("POST", this.__REST_API_SERVER + path, data, {
          headers: this.__HEADER,
          reportProgress: true,
        })
      )
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              this._eventCtrl.publish("page:loading:progress", 10);
              break;
            case HttpEventType.ResponseHeader:
              this._eventCtrl.publish("page:loading:progress", 25);
              break;
            case HttpEventType.DownloadProgress:
              this._eventCtrl.publish("page:loading:progress", 50);
              break;
            case HttpEventType.Response:
              this._eventCtrl.publish("page:loading:progress", 100);
              setTimeout(() => {
                loader
                  ? this._eventCtrl.publish("page:loading:status", false)
                  : null;
              }, 500);
              resolve(event.body);
              break;
          }
        },
        (res) => {
          if (res.status) {
            if ((res.status = 0)) {
              this.__nointernet();
            }

            if (res.error) {
              this.__switchError(res.error.code);
            }
          }

          loader ? this._eventCtrl.publish("page:loading:status", false) : null;
          reject(res);
        }
      );
  }
  public download(path: string, loader: boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("GET", this.__REST_WEB_SERVER + path, {
            headers: this.__HEADER,
            reportProgress: true,
            responseType: "blob",
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (res) => {
            if (res.status) {
              if ((res.status = 0)) {
                this.__nointernet();
              }
              if (res.error) {
                this.__switchError(res.error.code);
              }
            }

            loader
              ? this._eventCtrl.publish("page:loading:status", false)
              : null;
            reject(res);
          }
        );
    });
  }
  public raw(path: string, data: any, loader: boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest(
            "POST",
            `${this.__REST_WEB_SERVER}raw/${path}`,
            data,
            {
              headers: this.__HEADER,
              reportProgress: true,
              responseType: "blob",
            }
          )
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (res) => {
            if (res.status) {
              if ((res.status = 0)) {
                this.__nointernet();
              }
              if (res.error) {
                this.__switchError(res.error.code);
              }
            }

            loader
              ? this._eventCtrl.publish("page:loading:status", false)
              : null;
            reject(res);
          }
        );
    });
  }
  public post(path: string, data: any, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);
    return new Promise((resolve, reject) => {
      if (this.__is_ready) {
        this.performPost(path, data, loader, resolve, reject);
      } else {
        let inter = setInterval(() => {
          if (this.__is_ready) {
            clearInterval(inter);
            this.performPost(path, data, loader, resolve, reject);
          }
        }, 200);

        // this.__timeloop.push(setInterval(() => {
        //     if (this.__is_ready) {
        //         clearInterval(el)
        //         this.__timeloop.forEach(el => {
        //             this.performPost(path, data, loader, resolve, reject)
        //         });
        //     }
        // }, 200))
      }
    });
  }

  public delete(path: string, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("DELETE", this.__REST_API_SERVER + path, {
            responseType: "json",
            headers: this.__HEADER,
            reportProgress: true,
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                break;
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.DownloadProgress:
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (error) => {
            if (error.status) {
              if ((error.status = 0)) {
                this.__nointernet();
              }
            }
            loader
              ? this._eventCtrl.publish("page:loading:status", false)
              : null;
            reject(error);
          }
        );
    });
  }
  public upload(path: string, file: any, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);
    let form = new FormData();
    Object.keys(file).forEach((key) => {
      form.append(key, file[key]);
    });
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("POST", `${this.REST_WEB_SERVER}upload`, form, {
            headers: new HttpHeaders({
              Authorization: "Bearer " + this.__token,
            }),
            reportProgress: true,
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (error) => {
            reject(error);
            if (error.status) {
              if ((error.status = 0)) {
                this.__nointernet();
              }
            }

            loader
              ? this._eventCtrl.publish("page:loading:status", false)
              : null;
          }
        );
    });
  }


  public import(path: string, file: any, loader: boolean = true): Promise<any> {
    loader ? this._eventCtrl.publish("page:loading:status", true) : null;
    this._eventCtrl.publish("page:loading:progress", 0);
    let form = new FormData();
    Object.keys(file).forEach((key) => {
      form.append(key, file[key]);
    });
    return new Promise((resolve, reject) => {
      this._httpCtrl
        .request(
          new HttpRequest("POST", `${this.REST_WEB_SERVER}import`, form, {
            headers: new HttpHeaders({
              Authorization: "Bearer " + this.__token,
            }),
            reportProgress: true,
          })
        )
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this._eventCtrl.publish("page:loading:progress", 10);
                break;
              case HttpEventType.ResponseHeader:
                this._eventCtrl.publish("page:loading:progress", 25);
                break;
              case HttpEventType.DownloadProgress:
                this._eventCtrl.publish("page:loading:progress", 50);
                break;
              case HttpEventType.Response:
                this._eventCtrl.publish("page:loading:progress", 100);
                setTimeout(() => {
                  loader
                    ? this._eventCtrl.publish("page:loading:status", false)
                    : null;
                }, 500);
                resolve(event.body);
                break;
            }
          },
          (error) => {
            reject(error);
            if (error.status) {
              if ((error.status = 0)) {
                this.__nointernet();
              }
            }

            loader
              ? this._eventCtrl.publish("page:loading:status", false)
              : null;
          }
        );
    });
  }
  private __nointernet() {
    this._eventCtrl.publish("notify", {
      type: "error",
      content:
        "Erreur de connexion, veuillez vérifier votre connxion internet et réssayé!",
    });
  }
  private __switchError(code) {
    switch (code) {
      case 97:
        if (!this.__errors_call["97"]) {
          this.__errors_call["97"] = true;
          this._eventCtrl.publish("alert", {
            title: "Erreur",
            message: " Votre session a expiré, veuillez reconecter!",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this._eventCtrl.publish("pages:change:root", {
                    page:"Signin",
                    paylod:{
                      path:window.location.hash.replace('#/',"")
                    }
                  });
                  this.__errors_call["79"] = false;
                },
              },
            ],
          });
        }
        break;
      case 89:
        if (!this.__errors_call["89"]) {
          this.__errors_call["89"] = true;
          this._eventCtrl.publish("alert", {
            title: "Erreur",
            message:
              " Votre compte a été bloqué, veuillez contactez votre administrateur",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this._eventCtrl.publish("pages:change:root", "Signin");
                  this.__errors_call["89"] = false;
                },
              },
            ],
          });
        }
        // villez
        break;
        
      case 18:
        if (!this.__errors_call["18"]) {
          this._eventCtrl.publish("alert", {
            title: "Erreur des droits d’accès !",
            message:
              "Veuillez contactez votre administrateur système.",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  // this._eventCtrl.publish("pages:change:root", "Signin");
                  this.__errors_call["18"] = false;
                },
              },
            ],
          });
        }

        break;
      case 83:
        if (!this.__errors_call["83"]) {
          this.__errors_call["83"] = true;
          this._eventCtrl.publish("alert", {
            title: "Erreur",
            message: " Mot de passe ou e-mail incorrect ",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this.__errors_call["83"] = false;
                },
              },
            ],
          });
        }
        break;
      case 71:
        if (!this.__errors_call["71"]) {
          this.__errors_call["71"] = true;
          this._eventCtrl.publish("alert", {
            title: "Erreur",
            message:
              "le compte a été supprimer, veuillez contactez votre administrateur!",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this.__errors_call["71"] = false;
                },
              },
            ],
          });
        }
        break;
      case 79:
        if (!this.__errors_call["79"]) {
          this.__errors_call["79"] = true;
          this._eventCtrl.publish("alert", {
            title: "Erreur",
            message: " Mot de passe ou e-mail incorrect ",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this.__errors_call["79"] = false;
                },
              },
            ],
          });
        }
        break;
      case 73:
        if (!this.__errors_call["73"]) {
          this.__errors_call["73"] = true;
          this._eventCtrl.publish("alert", {
            title: "Erreur",
            message: "Impossible de trouver le compte ",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this.__errors_call["73"] = false;
                },
              },
            ],
          });
        }
        break;
      case 53:
        if (!this.__errors_call["53"]) {
          this.__errors_call["53"] = true;
          this._eventCtrl.publish("alert", {
            title: "Erreur",
            message: "Lien expiré ",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this.__errors_call["73"] = false;
                },
              },
            ],
          });
        }

        break;
      case 54:
        if (!this.__errors_call["54"]) {
          this.__errors_call["54"] = true;
          this._eventCtrl.publish("alert", {
            title: "Authentification",
            message:
              "Votre compte a été bien active mais n'a pas de profil veuillez contactez votre administrateur!",
            buttons: [
              {
                text: "D'accord",
                handler: () => {
                  this.__errors_call["54"] = false;
                },
              },
            ],
          });
        }




//         Erreur des droits d’accès !
// Veuillez contactez votre administrateur système.
        break;

      default:
        break;
    }
  }
  public get REST_API_SERVER() {
    return this.__REST_API_SERVER;
  }
  public get REST_WEB_SERVER() {
    return this.__REST_WEB_SERVER;
  }
  public set is_ready(v: boolean) {
    this.__is_ready = v;
  }
}



// WEBPACK FOOTER //
// ./src/providers/api.services.ts